<template>
    <div class="modal-card" style="width: 100%">
        <header class="modal-card-head">
            <p class="modal-card-title">Date cont</p>
            <button type="button" class="delete" @click="$emit('close')" />
        </header>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <section class="modal-card-body">
                <ValidationProvider rules="required|max:45" name="nume" v-slot="{ errors, valid }">
                    <b-field label="Nume" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input v-model.trim="name" required> </b-input>
                    </b-field>
                </ValidationProvider>

                <ValidationProvider rules="required|ibanFormat" name="iban" v-slot="{ errors, valid }">
                    <b-field label="IBAN" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input v-model.trim="iban" required> </b-input>
                    </b-field>
                </ValidationProvider>

                <ValidationProvider rules="email" name="email" v-slot="{ errors, valid }">
                    <b-field label="Email" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input type="email" v-model.trim="email"> </b-input>
                    </b-field>
                </ValidationProvider>

                <ValidationProvider rules="required|phonedigits:10" name="phone" v-slot="{ errors, valid }">
                    <b-field label="Telefon" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input v-model.trim="phone" required> </b-input>
                    </b-field>
                </ValidationProvider>

                <ValidationProvider rules="required" name="status" v-slot="{ errors, valid }">
                    <b-field label="Status" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-switch type="is-success" v-model="status"></b-switch>
                    </b-field>
                </ValidationProvider>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$emit('close')">Inchide</button>
                <button class="button is-success" @click="handleSubmit(save)">Salveaza</button>
            </footer>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import * as toast from '@/utils/toast';
export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({}),
    methods: {
        async save() {
            try {
                await this.$store.dispatch('admin/SaveAccount');
                toast.success('Contul a fost salvat cu succes!', 5000, 'is-top');
                return this.$emit('saved');
            } catch (err) {
                console.log(err);
                return false;
            }
        },
    },
    computed: {
        name: {
            get() {
                return this.$store.state.admin.formular230.account.name;
            },
            set(val) {
                this.$store.commit('admin/SET_ACCOUNT230_PROP', {
                    prop: 'name',
                    value: val,
                });
            },
        },
        iban: {
            get() {
                return this.$store.state.admin.formular230.account.iban;
            },
            set(val) {
                this.$store.commit('admin/SET_ACCOUNT230_PROP', {
                    prop: 'iban',
                    value: val,
                });
            },
        },
        email: {
            get() {
                return this.$store.state.admin.formular230.account.email;
            },
            set(val) {
                this.$store.commit('admin/SET_ACCOUNT230_PROP', {
                    prop: 'email',
                    value: val,
                });
            },
        },
        phone: {
            get() {
                return this.$store.state.admin.formular230.account.phone;
            },
            set(val) {
                this.$store.commit('admin/SET_ACCOUNT230_PROP', {
                    prop: 'phone',
                    value: val,
                });
            },
        },
        status: {
            get() {
                return this.$store.state.admin.formular230.account.status;
            },
            set(val) {
                this.$store.commit('admin/SET_ACCOUNT230_PROP', {
                    prop: 'status',
                    value: val,
                });
            },
        },
    },
};
</script>

<style></style>
